import { render } from "./Selections.vue?vue&type=template&id=1e07ba4c&scoped=true"
import script from "./Selections.vue?vue&type=script&lang=js"
export * from "./Selections.vue?vue&type=script&lang=js"

import "./Selections.vue?vue&type=style&index=0&id=1e07ba4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e07ba4c"]])

export default __exports__